const PasswordEyeHiddenIcon = ({ className = "", ...props }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M3 3L21 21"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
        />
        <path
            d="M10.58 10.58C10.21 10.95 10 11.45 10 12C10 13.1 10.9 14 12 14C12.55 14 13.05 13.79 13.42 13.42"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
        />
        <path
            d="M9.88 5.09C10.58 5.03 11.28 5 12 5C18.5 5 22 12 22 12C21.47 13.11 20.67 14.08 19.77 14.87M6.61 6.61C4.56 8.07 3.09 10.23 2 12C2 12 5.5 19 12 19C13.55 19 14.98 18.59 16.24 17.94"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default PasswordEyeHiddenIcon;
